import type { Components, Theme } from "@mui/material/styles";
import { buttonClasses } from "@mui/material/Button";

export const MuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    variant: "contained",
    disableElevation: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      "borderRadius": theme.shape.borderRadius,
      "fontWeight": "normal",
      "lineHeight": 1,
      "whiteSpace": "nowrap",
      "&.MuiButton-loading": { color: "transparent !important" },

      "variants": [
        {
          props: { size: "small" },
          style: { fontSize: theme.typography.pxToRem(12), padding: `${theme.spacing(1.2)} ${theme.spacing(2)}` },
        },
        { props: { size: "medium" }, style: { padding: `${theme.spacing(1.7)} ${theme.spacing(3)}` } },
        {
          props: { size: "large" },
          style: { fontSize: theme.typography.pxToRem(16), padding: `${theme.spacing(2)} ${theme.spacing(5)}` },
        },
        {
          props: { variant: "outlined" },
          style: {
            "color": theme.palette.text.primary,
            "backgroundColor": theme.palette.grey["50"],
            "borderColor": theme.palette.grey["400"],
            "&:hover": { backgroundColor: theme.palette.action.hover },
            "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
            [`&.${buttonClasses.disabled}`]: {
              color: theme.palette.action.disabled,
              borderColor: theme.palette.grey["200"],
            },

            "& .MuiButton-loadingIndicator": { color: theme.palette.text.primary },
          },
        },
        {
          props: { variant: "text", color: "primary" },
          style: {
            "color": theme.palette.primary.main,
            "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
          },
        },

        {
          props: { variant: "contained", color: "primary" },
          style: {
            "border": "1px solid",
            "borderColor": theme.palette.primary.main,

            "&:hover": { backgroundColor: theme.palette.primary["500"], borderColor: theme.palette.primary["500"] },
            "&:focus-visible": { outline: `2px solid ${theme.palette.primary["300"]}`, outlineOffset: 2 },
            "&.MuiButton-loading": { backgroundColor: theme.palette.primary[300] },
            "& .MuiButton-loadingIndicator": { color: theme.palette.primary.contrastText },
            [`&.${buttonClasses.disabled}`]: {
              borderColor: theme.palette.primary[300],
              backgroundColor: theme.palette.primary[300],
              color: theme.palette.primary.contrastText,
            },
          },
        },
      ],
    }),
  },
};
